import ComponentWithSocket from '../../../lib/component';
import { Component, Prop } from 'vue-property-decorator';
import { PhoneValidation } from '../../../utils/phone-validation';
import moment from 'moment';

// Ofertele anulate de clienti din cont. Oferta se sterge definitiv din licitare,
// asa ca aici vin din jurnalul `cancelledbids` (scris de api2 la anulare).
@Component
export default class CancelledBidsTab extends ComponentWithSocket {
    @Prop({ required: true }) auctionId: string;

    public data: {
        cancelledBids: any[];
        loaded: boolean;
    } = {
        cancelledBids: [],
        loaded: false,
    };

    constructor() {
        super();

        this.wsListener.onGet(
            'admin.auctions.cancelledBids',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.cancelledBids = data;
                }

                this.data.loaded = true;
            },
        );
    }

    mounted() {
        this.wsListener.sendGet('admin.auctions.cancelledBids', {
            auction: this.auctionId,
        });
    }

    beforeDestroy() {
        this.wsListener.destroy();
    }

    clientUser(bid: any): any {
        return (bid.auctionUser && bid.auctionUser.user) || {};
    }

    clientName(bid: any): string {
        const user = this.clientUser(bid);
        return `${user.firstName || ''} ${user.lastName || ''}`.trim() || '-';
    }

    clientPhone(bid: any): string {
        return PhoneValidation.format(this.clientUser(bid));
    }

    sourceLabel(source: string): string {
        if (source === 'mobile') return 'Mobil';
        if (source === 'site') return 'Site';
        return '-';
    }

    formatDate(date: string): string {
        return date ? moment(date).format('DD-MM-YYYY HH:mm') : '-';
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/auction-manage/cancelled-bids-tab/index.ts